// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
    background: linear-gradient(135deg, var(--primary) 0%, #7C3AED 100%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    gap: 16px;
}

.headline {
    color: #fff;
    font-weight: 700;
    font-size: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/googleLogin/googleLogin.css"],"names":[],"mappings":"AAAA;IACI,oEAAoE;IACpE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,SAAS;AACb;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB","sourcesContent":[".content {\n    background: linear-gradient(135deg, var(--primary) 0%, #7C3AED 100%);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 100vw;\n    height: 100vh;\n    gap: 16px;\n}\n\n.headline {\n    color: #fff;\n    font-weight: 700;\n    font-size: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
